import { CHECK_FRONTERA, SUCCESS_GET_FRONTERAS, FAILED_GET_FRONTERAS, RESET } from '../actions/Fronteras';

const checked = (state, action) => {

    switch (action.type) {

        case CHECK_FRONTERA:
            let { id, checked } = action.seleccionado

            if (state.Id !== id) {
                return state
            }

            return {
                ...state,
                Seleccionado: checked
            }
        default:
            return state
    }
}

const fronterasReducer = (state = [], action) => {
    switch (action.type) {
        case SUCCESS_GET_FRONTERAS:
            return action.fronteras;
        case FAILED_GET_FRONTERAS:
            return state
        case CHECK_FRONTERA:
            return state.map(cob =>
                checked(cob, action)
            )
        case RESET:
            return state.map(cob => {
                cob.Seleccionado = false
                return cob
            })
        default:
            return state
    }
}

export default fronterasReducer;